import appConfig from '../app.config'
import { defaultQuiz, defaultQuestion, generateAnswerForm, answerForm, defaultThemes } from './util'

const joinBaseUrl = appConfig.baseUrl + 'join/'

export default {
    setShowTopRightMenu(state) {
        state.showTopRightMenu = true
    },

    resetQuiz: function (state) {
        state.question = defaultQuiz()
    },

    setQuizStatus: function (state, status) {
        state.question.status = status
    },

    resetAnswer: function (state, questionIndex) {
        state.question.questions[questionIndex].answers = generateAnswerForm(2)
    },

    setRelateQuiz: function (state, data) {
        state.relateQuiz = data
    },

    setUserCredit: function (state, credit) {

        state.credit = parseFloat(credit.toFixed(2))
    },

    updateQuizQuestions: function (state, questions) {
        state.question.questions = questions
    },

    updateQuestion: function (state, question) {
        var payload = { ...question };

        if (payload.age == undefined) {
            payload.age = [0, 99]
        }

        if (payload.difficult == undefined) {
            payload.difficult = 5
        }

        if (payload.is_random_question_order == undefined) {
            payload.is_random_question_order = false
        }

        if (!payload.image_original) {
            payload.image_original = ''
        }

        if (!payload.image_coordinates) {
            payload.image_coordinates = {}
        }

        if (!payload.image_source) {
            payload.image_source = ''
        }

        if (!payload.background_image_original) {
            payload.background_image_original = ''
        }

        if (!payload.background_image_coordinates) {
            payload.background_image_coordinates = {}
        }

        if (!payload.background_image_source) {
            payload.background_image_source = ''
        }

        if (!payload.background_music) {
            payload.background_music = {
                id: 0,
                name: 'No Music',
                src: '',
                is_playing: '',
                volume: 0,
            }
        }

        if (!payload.theme_name) {
            payload.theme_name = 'theme_1'
        }

        if (!payload.themes) {
            payload.themes = defaultThemes()
        }

        state.question = payload
    },

    updateSetting: function (state, setting) {

        state.question[setting.field] = setting.value
    },

    updateSetRandomQuestion: function (state, value) {

        state.question.is_random_question_order = value
    },

    updateBackgroundColor: function (state, color) {

        state.question.background_color = color
    },

    updateBackgroundImage: function (state, imagePath) {

        state.question.background_image = imagePath
        // state.question.background_image_source = ""
    },

    updateExternalBackgroundImage: function (state, source) {
        state.question.background_image_source = source
    },

    updateQuizOriginalBackgroundImage(state, imagePath) {
        state.question.background_image_original = imagePath
    },

    updateQuizBackgroundCoordinates(state, coordinates) {
        if (!Object.keys(coordinates).length) return

        state.question.background_image_coordinates = coordinates
    },

    updateBackgroundImageBlur: function (state, value) {

        state.question.background_image_blur = value
    },

    updateBackgroundImageDarken: function (state, value) {

        state.question.background_image_darken = value
    },

    updateBackgroundImageOpacity: function (state, value) {

        state.question.background_image_opacity = value
    },

    updateBgMusicVolume: function (state, value) {

        state.question.background_music.volume = value
    },

    updateBackgroundType: function (state, type) {
        state.question.background_type = type
    },

    updateBackgroundMusic: function (state, data) {

        state.question.background_music = data
    },

    updateType: function (state, type) {

        state.question.type = type
    },

    addNewQuestion: function (state, question) {

        state.diffQuestionLength = [
            state.question.questions.length,
            state.question.questions.length + 1
        ]

        state.question.questions.push({
            ...defaultQuestion(),
            onCreate: true,
            ...question
        })
    },

    setQuestion: function (state, { questionIndex, question }) {
        state.question.questions[questionIndex] = question
    },

    addNewAnswer: function (state, questionIndex) {

        let questionType = state.question.questions[questionIndex].question_type

        if (questionType == 'sorting_list') {
            let firstAnswer = JSON.parse(JSON.stringify(state.question.questions[questionIndex].answers[0]))
            firstAnswer.title = ''
            firstAnswer.image = ''
            firstAnswer.is_correct = false

            state.question.questions[questionIndex].answers.push(firstAnswer)

            return
        }

        state.question.questions[questionIndex].answers.push(answerForm(1))
    },

    removeAnswer: function (state, { questionIndex, answerIndex }) {

        state.question.questions[questionIndex].answers.splice(answerIndex, 1)
    },

    removeQuestion: function (state, questionIndex) {

        state.question.questions.splice(questionIndex, 1)
    },

    toggleChooseAnswer: function (state, { questionIndex, answerIndex }) {

        state.question.questions[questionIndex].answers[answerIndex].is_correct = !state.question.questions[questionIndex].answers[answerIndex].is_correct
    },

    updateImageSearch: function (state, data) {
        state.imageSearchList = data
    },

    updateServerImageSelect: function (state, data) {
        state.imageServerSelect = data
    },

    updateQuestionImage: function (state, { questionIndex, imagePath }) {
        state.question.questions[questionIndex].image = imagePath
    },

    updateQuestionOriginalImage: function (state, { questionIndex, original }) {
        state.question.questions[questionIndex].image_original = original
    },

    updateQuestionExternalImageSource: function (state, { questionIndex, source }) {
        state.question.questions[questionIndex].image_source = source
    },

    updateQuestionCoordinates: function (state, { questionIndex, coordinates }) {
        state.question.questions[questionIndex].image_coordinates = coordinates
    },

    updateQuestionVideo: function (state, { questionIndex, videoPath }) {
        state.question.questions[questionIndex].video = videoPath
    },

    updateQuestionVideoStatus: function (state, { questionIndex, status }) {
        state.question.questions[questionIndex].external = status
    },

    updateVideoTime: function (state, { questionIndex, videoTimeDuration }) {
        state.question.questions[questionIndex].video_time = videoTimeDuration
    },

    updateVideoMute: function (state, { questionIndex, videoMute }) {
        state.question.questions[questionIndex].video_mute = videoMute
    },

    updateVideoProvider: function (state, { questionIndex, videoProvider }) {
        state.question.questions[questionIndex].video_provider = videoProvider
    },

    updateAnswerImage: function (state, { questionIndex, answerIndex, imagePath }) {
        state.question.questions[questionIndex].answers[answerIndex].image = imagePath
    },

    updateAnswerOriginalImage: function (state, { questionIndex, answerIndex, original }) {
        state.question.questions[questionIndex].answers[answerIndex].image_original = original
    },

    updateAnswerExternalImageSource: function (state, { questionIndex, answerIndex, source }) {
        state.question.questions[questionIndex].answers[answerIndex].image_source = source
    },

    updateAnswerCoordinates: function (state, { questionIndex, answerIndex, coordinates }) {
        state.question.questions[questionIndex].answers[answerIndex].image_coordinates = coordinates
    },

    updateAnswerVideo: function (state, { questionIndex, answerIndex, videoPath }) {

        state.question.questions[questionIndex].answers[answerIndex].video = videoPath
    },

    removeQuestionImage: function (state, questionIndex) {
        if (state.question.questions[questionIndex]) {
            state.question.questions[questionIndex].image = ''
            state.question.questions[questionIndex].image_original = ''
            state.question.questions[questionIndex].image_source = ''
            state.question.questions[questionIndex].image_coordinates = ''
        }
    },

    removeQuestionVideo: function (state, questionIndex) {
        if (state.question.questions[questionIndex]) {
            state.question.questions[questionIndex].video = null
            state.question.questions[questionIndex].video_time = null
            state.question.questions[questionIndex].video_mute = null
            state.question.questions[questionIndex].video_loop = false
            state.question.questions[questionIndex].video_provider = null

        }
    },

    removeAnswerImage: function (state, { questionIndex, answerIndex }) {
        if (state.question.questions[questionIndex]) {
            state.question.questions[questionIndex].answers[answerIndex].image = ''
            state.question.questions[questionIndex].answers[answerIndex].image_source = ''
        }
    },

    removeAnswerVideo: function (state, { questionIndex, answerIndex }) {

        state.question.questions[questionIndex].answers[answerIndex].video = ''
    },

    toggleMainModal: function (state, status) {

        state.modal.main.isOpen = status
    },

    updateMainModalMessage: function (state, message) {

        state.modal.main.message = message
    },

    updateQuestionTitle: function (state, { value, questionIndex }) {

        state.question.questions[questionIndex].title = value
    },

    updateAnswerTitle: function (state, { value, questionIndex, answerIndex }) {

        state.question.questions[questionIndex].answers[answerIndex].title = value
    },

    updateCreateQuestionStatus: function (state, status) {

        state.isCreateQuestionSuccess = status
    },

    toggleMainLoader: function (state, status) {

        state.loader.main.isLoading = status
    },

    updateQrCodeUrl: function (state, code) {

        state.qrCodeOptions.data = joinBaseUrl + '?code=' + code
    },

    toggleShowResultUserDevice: function (state) {

        state.question.show_result_on_user_device = !state.question.show_result_on_user_device
    },

    updateClassSubject: function (state, value) {

        state.question.class_subject = value
    },

    updateClassGrade: function (state, value) {

        state.question.class_grade = value
    },

    updateShowSchoolList: function (state, value) {

        state.question.show_school_list = value
    },

    updateShowSchoolCountryList: function (state, value) {
        state.question.show_school_country_list = value
    },

    updateSchoolId: function (state, value) {

        state.question.school_id = value
    },

    updateDescription: function (state, value) {

        state.question.description = value
    },

    updateCustomMessage: function (state, value) {

        state.question.custom_message = value
    },

    updateCountry: function (state, value) {

        state.question.countries = value
    },

    updateQuizImage: function (state, imagePath) {
        state.question.image = imagePath
    },

    updateQuizPlaceholderImage: function (state, imagePath) {
        state.question.image_placeholder = imagePath
    },

    updateQuizOriginalImage: function (state, imagePath) {
        state.question.image_original = imagePath
    },

    updateExternalQuizImageSource: function (state, source) {
        state.question.image_source = source
    },

    updateQuizCoordinates: function (state, coordinates) {
        state.question.image_coordinates = coordinates
    },

    updateQuizVideo: function (state, videoPath) {

        state.question.video = videoPath
    },

    updateRemoveAppPaddingX: function (state, status) {

        state.removeAppPaddingX = status
    },

    updateIsEndQuiz: function (state, status) {

        state.isEndQuiz = status
    },

    updateCurrentQuizIndex: function (state, index) {

        state.playingCurrentQuestionIndex = index
    },

    updatePlayerCount: function (state, playerCount) {

        state.playerCount = playerCount
    },

    updateUploadQuizImageStatus: function (state, status) {
        state.isUploadingQuizImage = status
    },

    updateUploadQuizVideoStatus: function (state, status) {
        state.isUploadingQuizVideo = status
    },

    updateUploadBgImageStatus: function (state, status) {
        state.isUploadingBackgroundImage = status
    },

    updateIsAudioLoaded: function (state, status) {

        state.isAudioLoaded = status
    },

    updateIsMuted: function (state, status) {
        state.isMuted = status
    },

    updateAudioDefinite: function (state, audio) {
        state.audioDefinite = audio
    },

    updateAudioPlucky: function (state, audio) {
        state.audioPlucky = audio
    },

    updateAudioWrong: function (state, audio) {
        state.audioWrong = audio
    },

    setFullScreenDesktop: function (state, { value, questionIndex }) {
        state.question.questions[questionIndex].fullscreen_desktop = value
    },

    setFullScreenMobile: function (state, { value, questionIndex }) {
        state.question.questions[questionIndex].fullscreen_mobile = value
    },

    setLoopVideo: function (state, { videoLoop, questionIndex }) {
        state.question.questions[questionIndex].video_loop = videoLoop
    },

    toggleAnswersRequired: function (state, { value, questionIndex }) {
        state.question.questions[questionIndex].answers_required = value
    },

    updateAnswersCount: function (state, { countIsCorrect, questionIndex }) {
        state.question.questions[questionIndex].answers_count = countIsCorrect
    },

    updateAudioSilence: function (state, audio) {
        state.audioSilence = audio
    },

    updateIntervalNoSleep: function (state, value) {
        state.intervalNoSleep = value
    },

    updateFrontPageSetting: function (state, value) {
        state.frontPageSetting = value
    },

    updateFrontPageBackgroundSet: function (state, value) {
        state.frontPageBackgroundSet = value
    },

    setOrderAbility: function (state, ability) {
        state.orderAbility = ability
    },

    addSong: function (state, { questionIndex, track }) {
        state.question.questions[questionIndex].spotify_track = {
            ...track,
            only_master: false
        }

        //state.question.questions[questionIndex].image = track.album_image
        state.question.questions[questionIndex].answers[0].title = `${track.name} - ${track.artists_name}`
    },

    deleteSong: function (state, questionIndex) {
        state.question.questions[questionIndex].spotify_track = null
    },

    togglePlaySongOnlyMaster: function (state, questionIndex) {
        state.question.questions[questionIndex].spotify_track = {
            ...state.question.questions[questionIndex].spotify_track,
            only_master: !state.question.questions[questionIndex].spotify_track.only_master
        }
    },

    toggleQuestionType: function (state, { questionIndex, type }) {
        state.question.questions[questionIndex].question_type = type

        if (type == 'typing_question' || type == 'hotspot' || type == 'scramble') return

        if (type != 'music') {
            state.question.questions[questionIndex].spotify_track = null
        }

        if (state.question.questions[questionIndex].answers.length === 1) {
            state.question.questions[questionIndex].answers = [
                ...state.question.questions[questionIndex].answers,
                ...generateAnswerForm(1)
            ]
        }

        if (type == 'puzzle') {
            state.question.questions[questionIndex].answers = [
                ...generateAnswerForm(1)
            ]
        }
    },

    toggleTypingAnswerRequired: function (state, { questionIndex, answerIndex, value }) {
        state.question.questions[questionIndex].answers[answerIndex].data.completely_correct = value
        state.question.questions[questionIndex].answers[answerIndex].data.accepted_percentage = (value == true) ? 100 : 0
    },

    toggleSortingMatchOption: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].answers.forEach(answer => {
            answer.data.completely_correct = value == 'complete'
        })
    },

    updateSortingMatchPercent: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].answers.forEach(answer => {
            answer.data.completely_correct = false
            answer.data.accepted_percentage = value
        })
    },

    afterDropSortingList: function (state, { questionIndex }) {
        state.question.questions[questionIndex].answers.forEach(answer => {
            answer.is_correct = false
        })
        state.question.questions[questionIndex].answers[0].is_correct = true
    },

    masterQuizId: function (state, id) {
        state.masterQuizId = id
    },

    toggleQuizIsPlaySongUser: function (state, value) {
        state.isPlaySongUser = value
    },

    toggleQuizIsPlaySongMaster: function (state, value) {
        state.isPlaySongMaster = value
    },

    updateDelayAnswer: function (state, value) {
        state.delayAnswer = value
    },

    updateDelayQuestion: function (state, value) {
        state.delayQuestion = value
    },

    updateTimeLimit: function (state, value) {
        state.timeLimit = value
    },

    updateMasterSound: function (state, value) {
        state.masterSound = value
    },

    updatePlayerSound: function (state, value) {
        state.playerSound = value
    },

    updateProgressBarStatus: function (state, value) {
        state.progressBarStatus = value
    },

    updateMasterResultSetting: function (state, value) {
        state.masterResult = Object.assign({
            playerAnswersBox: true,
            icon: true,
            topPlayerBox: true,
            bgBox: true
        }, value)
    },

    toggleQuizMasterQuestion: function (state, value) {
        state.masterQuestion = value
    },

    toggleQuizMasterEffect: function (state, value) {
        state.masterEffect = value
    },

    toggleQuizMasterBgMusic: function (state, value) {
        state.masterBgMusic = value
    },

    toggleQuizPlayerQuestion: function (state, value) {
        state.playerQuestion = value
    },

    toggleQuizPlayerEffect: function (state, value) {
        state.playerEffect = value
    },

    toggleQuizPlayerBgMusic: function (state, value) {
        state.playerBgMusic = value
    },

    toggleApproval: function (state, value) {
        if (typeof value !== 'undefined') {
            state.isApplyApproval = value
        } else {
            state.isApplyApproval = !state.isApplyApproval
        }
    },

    toggleShowSchoolList: function (state, value) {
        if (typeof value !== 'undefined') {
            state.isShowSchoolList = value
        } else {
            state.isShowSchoolList = !state.isShowSchoolList
        }
    },

    updateApprovalStatus: function (state, value) {
        state.question.approval_status = value
    },

    updateQuizTags: function (state, value) {
        state.question.tags = value
    },

    updateQuizAge: function (state, value) {

        state.question.age = value
    },

    updateQuizDifficult: function (state, value) {

        state.question.difficult = value
    },

    updateLimitPlayer: function (state, value) {

        state.question.limit_player = value
    },

    updateShowNumberQuestion: function (state, value) {

        state.question.show_number_question = value
    },

    setIsQuizNotFinishLogCreated: function (state, value) {
        state.isQuizNotFinishLogCreated = value
    },

    sliceAnswerTypingQuestion: function (state, index) {
        state.question.questions[index].answers = [state.question.questions[index].answers[0]]
    },

    updateQuestionCustomMessage: function (state, { value, questionIndex }) {
        state.question.questions[questionIndex].custom_message = value
    },

    toggleQuestionStatus: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].status = value
    },

    updateChartType: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].chart_type = value
    },

    puzzleQuestionStatus: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].puzzle_block = value
    },

    updateIsActiveOnly: function (state, status) {
        state.isActiveOnly = status
    },

    toggleShowCorrectAnswer: function (state) {
        state.question.show_correct_answer = !state.question.show_correct_answer
    },

    setParentQuizCode: function (state, code) {
        state.parentQuizCode = code
    },

    setReCaptchaResponse: function (state, response) {
        state.captchaResponse = response
    },

    setIsReconnectPopup: function (state, status) {
        state.isReconnectPopup = status
    },

    setUserPlayingInfo: function (state, info) {
        state.userPlayingInfo = info
    },

    setCoupon: function (state, code) {
        state.couponCode = code
    },

    setSchoolSubject: function (state, value) {
        state.subjectList = value
    },

    updateHotspotData: function (state, { data, questionIndex }) {
        state.question.questions[questionIndex].answers = data.map(e => {
            return {
                ...e,
                title: e.id,
                image: '',
                score: 0,
                data: {
                    sorting_choices: [],
                    accepted_percentage: 0,
                    completely_correct: true
                }
            }
        })
    },

    setCacheQuestions: function (state, data) {
        state.cacheQuestions = data
    },

    setBgSound: function (state, data) {
        state.bgSound = data
    },

    setIsPreviewMode: function (state, status) {
        state.isPreviewMode = status
    },

    setPlayMode: function (state, mode) {
        state.playMode = mode
    },

    toggleOpenUploadMedia: function (state, media) {
        state.uploadMedia = media
    },

    updateQuestionList: function (state, questions) {
        state.question.questions = questions
    },

    duplicateQuestion: function (state, question) {
        state.question.questions.push(question)
    },

    updateSortingList: function (state, { questionIndex, answers }) {
        state.question.questions[questionIndex].answers = answers
    },

    toggleQuestionIsAnywhere: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].is_anywhere = value
    },

    toggleFullWidthImageMobile: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].show_full_width_image_mobile = value
    },

    toggleQuestionMandatory: function (state, { questionIndex, value }) {
        state.question.questions[questionIndex].is_mandatory = value
    },

    getOnlyUidQuestions: function (state) {
        state.question.questions = state.question.questions.filter(e => e.uid)
    },

    setCreateNewQuiz: function (state, value) {
        state.isCreateNewQuiz = value
    },

    updateLiveStatus: function (state) {
        state.isLived = true
    },

    setThemes: function (state, themes) {
        state.question.themes = themes
    },

    setThemeName: function (state, name) {
        state.question.theme_name = name
    },

    openPaymentPopup: function (state, value) {
        state.isShowPaymentPopup = value
    },

    setWhitelistModal: function (state, value) {
        state.isShowWhitelistModal = value
    },

    setWhitelitModalData: function (state, value) {
        state.whitelitModalData = value
    },

    setMergeReportModal: function (state, value) {
        state.isShowMergeReportModal = value
    },

    setTypeUpgradeModal: function (state, value) {
        state.typeUpgradeModal = value
    },

    setPaymentModalTitleDescription: function (state, { title, description }) {
        state.paymentModalTitle = title
        state.paymentModalDescription = description
    },

    setSubPageMenu: function (state, data) {
        state.subPageMenu = data
    },

    setPageSliderPopup: function (state, { show, slug }) {
        state.pageSliderPopup.show = show
        state.pageSliderPopup.slug = slug
    },

    setShowNewsletterModal: function (state, value) {
        state.showNewsletterModal = value
    },

    setShowLogoutPopup: function (state, value) {
        state.showLogoutPopup = value
    },

    setShowFeideLogin: function (state, value) {
        state.showFeideLogin = value
    },

    setThemeSystemSettings: function (state, value) {
        state.themeSystemSettings = value
    },

    setGeoLocation: function (state, value) {
        state.geoLocation = value
    },

    setCanRead: function (state, value) {
        state.shareSetting.canRead = value
    },

    setCanEdit: function (state, value) {
        state.shareSetting.canEdit = value
    },

    setCanAccessReport: function (state, value) {
        state.shareSetting.canAccessReport = value
    },

    enableToEditQuiz: function (state, value) {
        state.enableToEditQuiz = value
    },

    setSystemSetting: function (state, value) {
        state.systemSetting = value
    },

    setQuizByUser: function (state, value) {
        state.quizByUser = value
    },

    setOriginalUserReports: function (state, value) {
        state.originalUserReports = value
    },

    setOriginalSharedReports: function (state, value) {
        state.originalSharedReports = value
    },
}
